import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from "swiper";
import "swiper/swiper-bundle.css";

Swiper.use([Navigation, Autoplay, Pagination, EffectFade]);

const HeaderSlider = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
		_settings.$indicator = document.querySelector(_settings.currentNumber);
	}

	function bindEvents() {
		window.addEventListener("scroll", handleScroll);
	}

	function handleScroll() {
		let sy = this.scrollY;
		let st = window.pageYOffset || document.documentElement.scrollTop;

		let bb = _settings.$el.getBoundingClientRect();

		// console.log(Math.abs(bb.top), _settings.$el.offsetHeight);

		if (Math.abs(bb.top) > _settings.$el.offsetHeight / 2) {
			_settings.slider.autoplay.stop();
		} else {
			_settings.slider.autoplay.start();
		}
	}

	function pad(number, length) {
		var str = "" + number;
		while (str.length < length) {
			str = "0" + str;
		}

		return str;
	}

	function initSwiper() {
		_settings.slider = new Swiper(_settings.el, {
			speed: 800,
			loop: true,
			slidesPerView: 1,
			autoplay: {
				delay: 7000
			},
			autoHeight: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			slideActiveClass: "header-slider__slide--active",
			navigation: {
				nextEl: ".header-slider__nav-button--next",
				prevEl: ".header-slider__nav-button--prev"
			},
			on: {
				init: function() {
					if (!this.params.loop) _settings.$prevEl.disabled = true;
				},
				slideChangeTransitionStart: function(e) {
					var index = e.realIndex;

					_settings.$indicator.innerHTML = pad(index + 1, 2);
				},
				slideChangeTransitionEnd: function(e) {
					_settings.currentSlide = _settings.$el.querySelector(
						".header-slider__slide--active"
					);
				}
			}
		});
	}

	function init() {
		cacheDom();
		bindEvents();
		initSwiper();

		return _self;
	}

	return init();
};

export { HeaderSlider };
